var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmnsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2387,
    height: 1007,
    viewBox: "0 0 2387 1007",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M784.967 569.343C812.978 569.343 838.959 573.725 862.91 582.489C887.268 591.253 908.175 604.399 925.631 621.928C943.493 639.456 957.295 661.367 967.038 687.659C977.187 713.952 982.262 744.826 982.262 780.281C982.262 811.354 978.202 840.038 970.083 866.33C961.964 892.623 949.582 915.329 932.938 934.451C916.699 953.573 896.199 968.712 871.436 979.866C847.078 990.622 818.255 996 784.967 996H597.415V569.343H784.967ZM709.786 897.985H781.496C793.106 897.985 804.375 896.117 815.302 892.382C826.229 888.646 835.96 882.533 844.497 874.043C853.034 865.214 859.863 853.837 864.985 839.914C870.107 825.991 872.669 809.011 872.669 788.975C872.669 770.637 870.79 754.166 867.034 739.563C863.619 724.621 857.814 711.886 849.619 701.358C841.424 690.831 830.497 682.85 816.838 677.417C803.521 671.644 786.959 668.757 767.154 668.757H709.786V897.985Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.131 569.343H292.974L441.809 835.129V569.343H546.137V996H431.912L285.509 732.312V996H182.131V569.343Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1457 11H1594.44L1762.71 311.704V11L1885 11V511H1753.81L1577 200.21V511H1457V11Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.43 11.1909H1419.97L1246.3 507.792H1133.77L1307.43 11.1909Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.16 569.343H1133.7V996H1021.16V569.343Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0615 569.343H130.598V996H18.0615V569.343Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M540.058 11.1909H733.304L816.962 338.702H818.397L901.157 11.1909H1091.62V507.792H969.516V131.359L866.181 507.792H765.501L662.211 131.359H662.166V507.792H540.058V11.1909Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.744 315.829H305.292L251.466 144.793H250.085L199.744 315.829ZM186.486 11.1909L319.916 11.1909L504.329 507.792H369.518L341.946 416.789H167.258L134.137 507.792H0L186.486 11.1909Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1329.84 831.074H1420.27L1374.15 684.128H1372.97L1329.84 831.074ZM1318.48 569.343L1432.79 569.343L1590.79 996H1475.29L1451.67 917.814H1302.01L1273.63 996H1158.71L1318.48 569.343Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1945.77 338.528H2076.5C2073 402 2134.91 417.5 2163 417.5C2213.73 417.5 2245 386 2241.69 357.053C2237.23 317.986 2188.03 310.501 2071.5 284.671C1977.77 263.895 1955.03 187.683 1954.8 154.576C1954.1 96.9888 1993.56 0 2156.95 0C2320.33 0 2358.86 101.185 2357.7 160.871H2233.36C2227.78 116.762 2191.55 99 2158 99C2134 99 2091.98 109.187 2089.56 137.789C2086.52 173.794 2159.72 191.646 2252.81 212.629C2345.9 233.612 2372.99 314.048 2372.99 343.424C2372.99 372.801 2378.55 517.584 2151.39 517.584C1969.66 517.584 1938.59 398.213 1945.77 338.528Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmnsLogo);
export default __webpack_public_path__ + "static/media/amnsLogo.9cd62a71e793160d0f9408f4ad400b1e.svg";
export { ForwardRef as ReactComponent };